import React from "react";
import { TouchableOpacity, View, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";

export interface ToggleSwitchProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  disabled?: boolean;
  testID?: string;
}

export function ToggleSwitch({ value, onValueChange, disabled = false, testID }: ToggleSwitchProps) {
  const { colors } = useTheme();

  return (
    <TouchableOpacity
      testID={testID}
      style={[
        styles.toggleSwitch,
        {
          backgroundColor: value ? colors.primary : colors.border,
          opacity: disabled ? 0.5 : 1,
        },
      ]}
      onPress={() => !disabled && onValueChange(!value)}
      disabled={disabled}
      activeOpacity={0.7}
    >
      <View
        style={[
          styles.toggleThumb,
          {
            backgroundColor: colors.card,
            transform: [{ translateX: value ? 20 : 2 }],
          },
        ]}
      />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  toggleSwitch: {
    width: 44,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    padding: 2,
  },
  toggleThumb: {
    width: 20,
    height: 20,
    borderRadius: 10,
    boxShadow: "0 1px 2.22px 0 rgba(0, 0, 0, 0.22)",
    elevation: 3,
  },
});
